// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3RjAg","box":"WorkspacesBox_box__27zHM","node":"WorkspacesBox_node__2U6YU"};